import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "result-game-info" }
const _hoisted_2 = {
  key: 0,
  class: "stars"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

import { computed } from 'vue'
import { marked } from 'marked'
import CResultBanner from '@/components/CResultBanner.vue'
import { Ranking } from '@/model/CompetitionResult'
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  __name: 'CResultGameInfo',
  props: {
    data: {}
  },
  setup(__props: any) {

const props = __props
const { t } = useI18n()
const scoreText = computed(() => {
  return marked(t('resultView.gameFinished.score', { score: props.data.score }))
})
const rankText = computed(() => {
  return marked(t('resultView.gameFinished.rank', { rank: props.data.rank }))
})

return (_ctx: any,_cache: any) => {
  const _component_t_card = _resolveComponent("t-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.data.rank === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _createVNode(_component_t_card, {
      class: _normalizeClass(["content", _ctx.data.rank != 1 ? 'not-win' : ''])
    }, {
      default: _withCtx(() => [
        _createVNode(CResultBanner, { class: "banner" }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "text congrats",
              innerHTML: rankText.value
            }, null, 8, _hoisted_3)
          ]),
          _: 1
        }),
        _createElementVNode("p", {
          class: "text",
          innerHTML: scoreText.value
        }, null, 8, _hoisted_4)
      ]),
      _: 1
    }, 8, ["class"])
  ]))
}
}

})